package pl.michal_cyran.brand_hub.subpages.tutoring.composables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.FeaturedCardStyle
import pl.michal_cyran.brand_hub.FeaturedIconBoxStyle
import pl.michal_cyran.brand_hub.IconBoxStyle
import pl.michal_cyran.brand_hub.SmallText
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun PropertyCard(
    title: String,
    description: String,
    icon: @Composable ((size: IconSize) -> Unit),
    featured: Boolean = false,
    index: Int = 0,
) {
    val cm = ColorMode.current.toSitePalette()

    val cardModifier = if (featured) FeaturedCardStyle.toModifier() else CardStyle.toModifier().backgroundColor(cm.cardBg)

    VisibilityAware(
        modifier = cardModifier
    ) {
            isVisible ->
        Column(
            modifier = Modifier
                .opacity(if (isVisible) 1 else 0)
                .transform {
                    translateY(if (isVisible) 0.px else 24.px)
                    scale(if (isVisible) 1.0 else 0.96)
                }
                .transition(
                    Transition.of("opacity", 0.5.s, EaseOut, (index * 300).ms),
                    Transition.of("transform", 0.5.s, EaseOut, (index * 300).ms)
                )
        ) {
            Box(
                modifier = (if (featured) FeaturedIconBoxStyle.toModifier() else IconBoxStyle.toModifier())
                    .margin(12.px)
                    .transform { scale(if (isVisible) 1.0 else 0.5) }
                    .transition(
                        Transition.of("transform", 0.4.s, EaseOut, (index * 300 + 150).ms)
                    )
            ) {
                icon(IconSize.XXL)
            }

            H4 {
                Text(title)
            }
            P(
                SmallText.toModifier().toAttrs()
            ) {
                Text(description)
            }
        }
    }
}